import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import News from "./components/News";
import Weather from "./components/Weather";
import Astrology from "./components/Astrology";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

function Nav() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="astrology" element={<Astrology />} />
        <Route path="weather" element={<Weather />} />
        <Route path="news" element={<News />} />
        <Route
          path="*"
          element={
            <div style={{ padding: "1rem" }}>
              <p>There's nothing here! Go to the home page :)</p>
              <Link to="/">Dashboard</Link>
            </div>
          }
        />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default Nav;
